import EdgeCommon from "../edgeCommon";

export default class Edge extends EdgeCommon {
  constructor(isChild) {
    super(isChild);
    this.partId = 'center_island_edge';
    this.partName = 'Edge';
    this.dbName = 'Edge Profile';
    // this.isStoneFeature = true;
    this.customClassName = "edge";
    this.translateId = "visualizer.kitchen.center_island.center_island_edge";
    this.hasNoVisualizerLayers = true;
    if (isChild) {
      this.shouldLoadInMultipleGroups = true;
    }
  }

}
